import Session from "@/utils/Session";

/* eslint-disable */
export default {
    newAxios: () => {
        var axios = require("axios");
        let session = new Session();
        let token = session.exists() ? session.accessToken.get() : "";
        if (token != null && token.trim() !== '')
        {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        return axios;
    }
}
